"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDeleteCascades = void 0;
const lodash_1 = __importDefault(require("lodash"));
const ChangeSet_1 = require("./ChangeSet");
// function getDeleteScript()
function processDependencies(changeSet, result, allForeignKeys, fkPath, table, baseCmd, dbinfo, usedTables) {
    if (result.find(x => x.title == table.pureName))
        return;
    const dependencies = allForeignKeys.filter(x => x.refSchemaName == table.schemaName && x.refTableName == table.pureName);
    for (const fk of dependencies) {
        const depTable = dbinfo.tables.find(x => x.pureName == fk.pureName && x.schemaName == fk.schemaName);
        const subFkPath = [...fkPath, fk];
        if (depTable && !usedTables.includes(depTable.pureName)) {
            processDependencies(changeSet, result, allForeignKeys, subFkPath, depTable, baseCmd, dbinfo, [
                ...usedTables,
                depTable.pureName,
            ]);
        }
        const refCmd = {
            commandType: 'delete',
            from: {
                name: {
                    pureName: fk.pureName,
                    schemaName: fk.schemaName,
                },
            },
            where: {
                conditionType: 'exists',
                subQuery: {
                    commandType: 'select',
                    selectAll: true,
                    from: {
                        name: {
                            pureName: fk.pureName,
                            schemaName: fk.schemaName,
                        },
                        alias: 't0',
                        relations: subFkPath.map((fkItem, fkIndex) => ({
                            joinType: 'INNER JOIN',
                            alias: `t${fkIndex + 1}`,
                            name: {
                                pureName: fkItem.refTableName,
                                schemaName: fkItem.refSchemaName,
                            },
                            conditions: fkItem.columns.map(column => ({
                                conditionType: 'binary',
                                operator: '=',
                                left: {
                                    exprType: 'column',
                                    columnName: column.columnName,
                                    source: { alias: `t${fkIndex}` },
                                },
                                right: {
                                    exprType: 'column',
                                    columnName: column.refColumnName,
                                    source: { alias: `t${fkIndex + 1}` },
                                },
                            })),
                        })),
                    },
                    where: {
                        conditionType: 'and',
                        conditions: [
                            (0, ChangeSet_1.extractChangeSetCondition)(baseCmd, `t${subFkPath.length}`),
                            // @ts-ignore
                            ...table.primaryKey.columns.map(column => ({
                                conditionType: 'binary',
                                operator: '=',
                                left: {
                                    exprType: 'column',
                                    columnName: column.columnName,
                                    source: { alias: 't0' },
                                },
                                right: {
                                    exprType: 'column',
                                    columnName: column.columnName,
                                    source: {
                                        name: fk,
                                    },
                                },
                            })),
                        ],
                    },
                },
            },
        };
        let resItem = result.find(x => x.title == fk.pureName);
        if (!resItem) {
            resItem = {
                title: fk.pureName,
                commands: [],
            };
            result.push(resItem);
        }
        resItem.commands.push(refCmd);
    }
}
function getDeleteCascades(changeSet, dbinfo) {
    const result = [];
    const allForeignKeys = lodash_1.default.flatten(dbinfo.tables.map(x => x.foreignKeys));
    for (const baseCmd of changeSet.deletes) {
        const table = dbinfo.tables.find(x => x.pureName == baseCmd.pureName && x.schemaName == baseCmd.schemaName);
        if (!table.primaryKey)
            continue;
        processDependencies(changeSet, result, allForeignKeys, [], table, baseCmd, dbinfo, [table.pureName]);
        // let resItem = result.find(x => x.title == baseCmd.pureName);
        // if (!resItem) {
        //   resItem = {
        //     title: baseCmd.pureName,
        //     commands: [],
        //   };
        //   result.push(resItem);
        // }
        // resItem.commands.push(changeSetDeleteToSql(baseCmd));
    }
    return result;
}
exports.getDeleteCascades = getDeleteCascades;
